import type { ReactElement } from 'react';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { heroPattern } from '@noah-labs/fe-shared-ui-assets';
import ReactLottie from 'lottie-react';

type PpHeroAnimatedLayers = {
  hideOnMobile?: boolean;
};

const StyledStack = styled(Stack)<PpHeroAnimatedLayers>(({ hideOnMobile, theme }) => ({
  position: 'absolute',
  top: theme.spacing(8),
  zIndex: 0,
  [theme.breakpoints.down('lg')]: {
    alignItems: 'flex-end',
    width: '100vw',
  },
  ...(hideOnMobile
    ? {
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
      }
    : {
        [theme.breakpoints.down('sm')]: {
          right: theme.spacing(-10),
          top: theme.spacing(10),
        },
      }),
}));

export function HeroAnimatedLayers({ hideOnMobile }: PpHeroAnimatedLayers): ReactElement {
  return (
    <StyledStack hideOnMobile={hideOnMobile}>
      <ReactLottie
        autoPlay
        loop
        animationData={heroPattern}
        style={{ height: '100%', width: '100%' }}
      />
    </StyledStack>
  );
}
